!function (factory) {
  if (typeof module !== 'undefined') { module.exports = factory } else {
    define('app/models/sePlayIndexMdl',[
      'lodash',
      'backboneMdl',
      'app/config/constants',
      'app/models/sePlayPageMdl',
      'jquery',
      'app/helper/logging.se'
    ], factory)
  }
}(function (
  _,
  BackboneBase,
  CONSTANTS,
  sePlayPageMdl,
  _jQ,
  seLogging
) {
  var
    console = window.console,
    $ = $ || _jQ

  var LOG_LABEL = 'PlINDEX MDL'

  var STATUS = CONSTANTS.STATUS

  var
    PlayIndexPageCollectionModel = BackboneBase.Collection.extend({
      // basics
      model: sePlayPageMdl

    })

  var
    /**
     * @type PlayIndexModel
     * @extends BackboneBaseModel
     */
    PlayIndexModel = BackboneBase.Model.extend(/** @lends PlayIndexModel.prototype */ {
      // basics
      defaults: {
        pageElementOrder: '',
        experiments: [],
        jsml: null, // raw orig JSML object
        options: null, // parse options
        settings: null
      },
      pages: null, // placeholder for pages collection

      status: null,

      isParsing: false, // status while parsing in new pages -> in order to ignore page sorting adding / removing etc.
      parsingQueue: [],
      isAdding: false, // status while adding a page -> in order to ignore the page resorting

      language: null,

      init: function (params, options) {
        var _this = this

        if (options && options.language) {
          _this.language = options.language
          _this.language.on('hasLoaded', function () {
            _this.translate()
          })
        }

        _this.pages = new PlayIndexPageCollectionModel()

      },

      // read in
      /**
       * @param {JsonML} indexJsml
       * @param {{newPageCId?: string, newPageId?: string}} [options]
       */
      parse: function (indexJsml, options) {
        var _this = this,
          _pages = _this.pages,

          PageModel = _this.pages.model,
          _res = $.Deferred()

        options = _.merge({
          newPageCId: null,
          newPageId: null
        }, options || {})

        var isNewPageParseIn = !!options.newPageCId

        if (_this.status === STATUS.CHANGED) {
          if (isNewPageParseIn) {
            // while index has changes only allow a parse if it is for a new page
          } else {
            // otherwise abort; changes will be saved soon and a new parse will be triggered
            return
          }
        }

        if (!_this.isParsing) {
          _this.isParsing = _res.promise()
          _this.isParsing.then(function () {
            if (_this.parsingQueue.length) {
              _this.parse.apply(_this, _this.parsingQueue.shift())
            }
          })

        } else {
          _this.parsingQueue.push(arguments)
          return
        }

        var curPageIdxPos = -1,
            resaveNeeded = false

        if (isNewPageParseIn) {
          // on new-page-parse-in only parse in the awaited new page, nothing else.

          _.forEach(indexJsml, function (val) {
            if (val[0]) {
              switch (val[0]) {
                case 'Page':
                  curPageIdxPos++

                  var
                    pageJsml = val,
                    pageId = val[1].Id || val[1].id,
                    page = _pages.get(pageId)

                  if (!page && options.newPageId === pageId) {

                    page = _pages.get(options.newPageCId)

                    if (page && !page.isDeleted) {
                      page.setId(pageId)
                      page.cset('indexJsml', pageJsml)
                      page.unsetTemporary()
                      //page.set('label', '')
                      resaveNeeded = true

                    } else {
                      // page was deleted in frontend before it was created by the backend
                      console.warn(LOG_LABEL, 'could not find related page object based on given pageCid', options.newPageCId)

                    }
                  }

                  break
              }
            }
          })

        } else {
          _this.cset('jsml', indexJsml)
          _this.cset('options', options)
          _this.cset('settings', indexJsml[1])

          var
            experiments = [],
            randompages = {}

          // only if this is a regular parse-in (not a new-page parse in)
          // mark all pages for update
          // delete all not-updated, not pages afterwards
          _pages.forEach(function (page) {
            if (!page.isTemporary && !page.isDeleted) {
              page.needsUpdate = true
            }
          })

          _.forEach(indexJsml, function (val) {
            if (val[0]) {
              switch (val[0]) {
                case 'Page':
                  curPageIdxPos++

                  var pageJsml = val,
                    pageId = val[1].Id || val[1].id,
                    page = _pages.get(pageId)

                  if (!page) {
                    page = new PageModel({ id: pageId })

                    _pages.add(page)
                    _pages.moveChildToPos(page, curPageIdxPos)

                  }

                  page.set('label', pageJsml[1].Display_Label)

                  var pagePos = page.getPosition()
                  if (pagePos !== curPageIdxPos) {
                    _pages.moveChildToPos(page, curPageIdxPos)
                    // console.debug(LOG_LABEL, 'parse', 'page pos', pageId, pagePos, '->', curPageIdxPos)
                  }

                  delete (page.needsUpdate)

                  //page.set('nr', curPageIdxPos + 1);

                  break
                case 'ChoiceSet': // experiment
                  var expId = val[1].Id

                  experiments.push({
                    id: expId,
                    info: val[1]
                  })

                  break
                /*
                 <RandomiseGroup Display_Label='Randomisation Group RAND_A' Id='' Data_Label='RAND_A' >
                 <Level Display_Label='P2' Id='RAND_A_slot1' Data_Label='RAND_A_RAND_A_slot1' Data_Description='P2'/>
                 <Level Display_Label='P21' Id='RAND_A_slot2' Data_Label='RAND_A_RAND_A_slot2' Data_Description='P21'/>
                 </RandomiseGroup>
                 */
                case 'RandomiseGroup':

                  var groupId = val[1].Data_Label.replace('RAND_', '')

                  _.forEach(val, function (level, idx) {
                    if (idx < 2 || !level[0].match(/^level$/i)) return

                    var
                      tmpPId = level[1].Display_Label

                    randompages[tmpPId] = {
                      pid: tmpPId,
                      group: groupId
                    }
                  })

                  break
                case 'Quota':
                case 'Layout':
                default:
                  break
              }

            }
          })

          _this.translate()

          _pages.forEach(function (page) {
            if (page && page.needsUpdate) {
              _pages.remove(page)
            }
          })

          // add random info also to pages
          _pages.forEach(function (page) {
            if (randompages[page.id]) {
              page.cset('randomgroup', randompages[page.id].group)
            }
          })

          _this.cset('experiments', experiments)

        }

        _this.isParsing = false
        _res.resolve()

        if(resaveNeeded){
          _this.setStatus(STATUS.CHANGED)
        }
      },

      //write out

      _changedSinceLastJsmlCreation: false,
      /** @type JsonML|null */
      _latestJsml: null,
      /**
       * @param {boolean} [onlyIfChanged]
       * @returns {JsonML|null|boolean}
       */
      toJsml: function (onlyIfChanged) {
        var _this = this,
          _pages = _this.pages,
          _pageIds = _pages.pluck('id')

        // console.log('toJsml', _pageIds)

        if (_this.status !== STATUS.CHANGED) {

          if (onlyIfChanged) {
            return false
          }

          if (_this._latestJsml) {
            return _this._latestJsml
          }
        }

        var
          /** @type JsonML */
          newIndexJsml = ['Survey'],
          /** @type JsonML */
          rawIndexJsml = _this.get('jsml'),
          /** @type object|null */
          indexAttributes = _this.get('settings')

        newIndexJsml.push(indexAttributes)

        _.forEach(rawIndexJsml, function (val, idx) {
          //console.log(LOG_LABEL, 'index part', val);
          if (idx > 1) {
            switch (val[0]) {
              case 'RandomiseGroup':
              case 'Page':
                // skip pages and random groups
                break
              case 'ChoiceSet':
              case 'Quota':
              case 'Layout':
              default:
                newIndexJsml.push(val)
                break
            }
          }
        })

        var randomGroups = {},
          hasTemporaryPages = false,
          pagesWithDoubleEntriesIssue = []

        _pageIds.map(function (pageId) {
          var page = _pages.get(pageId)

          if(!page || hasTemporaryPages){
            return
          }

          if (page.isTemporary) {
            // register "fact" that there are temporary pages -> this index can not be saved
            // until the create->parse-loop is not finished and they are properly created in the backend
            // and have an ID that is valid on the backend
            hasTemporaryPages = true
            return
          }

          if (page.isDeleted) {
            // ignore page
            return
          }

          var
            pageSimpleJsml = page.toSimpleJsml(),
            tmpRandomGroup = page.get('randomgroup')

          if(JSON.stringify(newIndexJsml).indexOf(JSON.stringify(pageSimpleJsml)) !== -1){
            console.log('toJsml double', _pages.pluck('id'), newIndexJsml, pageSimpleJsml, page)
            pagesWithDoubleEntriesIssue.push([page.cid, page.id, pageSimpleJsml[1].Id, _.cloneDeep(page.toJson())]) // add but later abort
          }

          newIndexJsml.push(pageSimpleJsml)

          if (tmpRandomGroup) {
            randomGroups[tmpRandomGroup] = randomGroups[tmpRandomGroup] || []
            randomGroups[tmpRandomGroup].push(page.id)
          }
        })

        if(pagesWithDoubleEntriesIssue.length){
          // TODO: move this into the controller - maybe throw/catch
          console.warn(LOG_LABEL, 'abort export to JSML because of double entries in pages', newIndexJsml)
          seLogging.remoteLog(LOG_LABEL, 'abort export to JSML because of double entries in pages', newIndexJsml, pagesWithDoubleEntriesIssue)
          seLogging.warn('Syncing with server', 'Re-syncing the current survey state with the server.')
          _this.setStatus(STATUS.FAILED)
          _this.saveForced()
          setTimeout(function(){
            window.location.reload()
          }, 1000)
          return null
        }

        if (hasTemporaryPages) {
          console.info(LOG_LABEL, 'abort export to JSML because of temporary pages', hasTemporaryPages)
          return null
          // can't save while
          // - temporary pages are about to be filled with data
          // - deleted pages are not properly destroyed (yet)
        }

        /*
         <RandomiseGroup Display_Label='Randomisation Group RAND_A' Id='' Data_Label='RAND_A' >
         <Level Display_Label='P2' Id='RAND_A_slot1' Data_Label='RAND_A_RAND_A_slot1' Data_Description='P2'/>
         <Level Display_Label='P21' Id='RAND_A_slot2' Data_Label='RAND_A_RAND_A_slot2' Data_Description='P21'/>
         </RandomiseGroup>
         */
        var groupNames = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
          groupIdx = 0

        _.forEach(randomGroups, function (group) {

          if (groupIdx > groupNames.length) { // TODO: make this independent of the number of groups - but 26 should be fine for now
            console.error(LOG_LABEL, 'too many random groups', groupIdx)
            return
          }

          var
            tmpGroupId = 'RAND_' + groupNames[groupIdx],
            tmpGroup = ['RandomiseGroup', {
              Display_Label: 'Randomisation Group ' + tmpGroupId,
              Data_Label: tmpGroupId
            }]

          var rPageIdx = 1
          _.forEach(group, function (rPage) {
            tmpGroup.push(['Level', {
              Display_Label: rPage,
              Data_Description: rPage,
              Id: tmpGroupId + '_slot' + rPageIdx,
              Data_Label: tmpGroupId + '_slot' + rPageIdx
            }])

            rPageIdx++
          })

          groupIdx++

          newIndexJsml.push(tmpGroup)
        })

        _this._latestJsml = _.cloneDeep(newIndexJsml)

        return newIndexJsml
      },

      /**
       * @returns {object|null} current index' attributes
       */
      getSettings: function () {
        var _this = this
        return _this.cget('settings')
      },
      /**
       * save new settings (merges with existing settings) and triggers a sync via change
       * @param {object} settingsObj
       */
      saveSettings: function (settingsObj) {
        var _this = this

        var curSettings = _this.getSettings(),
          newSettings = _.merge(curSettings, settingsObj)

        _this.cset('settings', newSettings)

        _this.trigger('hasChanged')
      },
      /**
       * uses the given language model to translate all index settings
       * @param {LanguageMdl} languageMdl
       */
      translate: function (languageMdl) {
        var _this = this

        languageMdl = languageMdl || _this.language
        if (!languageMdl) return

        var indexSettings = _this.getSettings(),
          baseTranslations = languageMdl.getBaseTranslations()

        if (!baseTranslations || baseTranslations.length === 0)
          return

        _.each(baseTranslations, function (translObj) {
          var strId = translObj.stringUid
          if (typeof indexSettings[strId + '_orig'] === 'undefined') {
            indexSettings[strId + '_orig'] = indexSettings[strId]
          }
          indexSettings[strId] = translObj.value
        })

        _this.saveSettings(indexSettings)
      }

    })

  return PlayIndexModel

})
;
